import { createSlice } from '@reduxjs/toolkit';
import { CLOTHES_CHANGER_MODEL_LIST } from '../../config/dataConfig/FJClothesChangerData';

export const DEFAULT_MODEL = CLOTHES_CHANGER_MODEL_LIST[0];

export const FJSliceClothesChanger = createSlice({
    name: 'clothesChanger',
    initialState: {
        peopleImageInfo: {},
        clothesImageInfo: {},
        selectedStyle: '',
        clothesInfo: {},
        tab: 0,
        selectedModel: DEFAULT_MODEL.value,
        isUploading: false,
    },
    reducers: {
        setSlicePeopleImageInfoAction: (state, action) => {
            state.peopleImageInfo = action.payload;
        },
        setSliceClothesImageInfoAction: (state, action) => {
            state.clothesImageInfo = action.payload;
        },
        setSliceSelectedStyleAction: (state, action) => {
            state.selectedStyle = action.payload;
        },
        setSliceClothesInfoAction: (state, action) => {
            state.clothesInfo = action.payload;
        },
        setSliceTabAction: (state, action) => {
            state.tab = action.payload;
        },
        setSliceSelectedModelAction: (state, action) => {
            state.selectedModel = action.payload;
        },
        setSliceIsUploadingAction: (state, action) => {
            state.isUploading = action.payload;
        },
    },
});

export const {
    setSlicePeopleImageInfoAction,
    setSliceClothesImageInfoAction,
    setSliceSelectedStyleAction,
    setSliceClothesInfoAction,
    setSliceTabAction,
    setSliceSelectedModelAction,
    setSliceIsUploadingAction,
} = FJSliceClothesChanger.actions;

export default FJSliceClothesChanger.reducer;
